<template>
  <div :class="btnClass">
    <slot></slot>
  </div>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';

export default {
  name: `${NAME_PRE}-button-group`,
  mounted() {
    this.validator();
  },

  computed: {
    btnClass() {
      const classes = [`${NAME_PRE}-button-group`];
      return classes;
    },
  },

  methods: {
    // 校验内部元素是否是我们的button组件，如果不是报错
    validator() {
      let children = this.$el.children;
      for (let i = 0; i < children.length; i++) {
        console.assert(
          children[i].tagName === 'BUTTON',
          '子元素必须是button类型'
        );
      }
    },
  },
};
</script>
